let Base64 = require('js-base64').Base64
/**
 * Base64 编码
 */
function encode64(data){
	let data2 = JSON.stringify(data)
	return Base64.encode(data2)
}
/**
 * Base64 解码
 */
function decode64(data,type = false){
	let base64Decode = Base64.decode(data)
	// 把json转换回原来类型（但还是字符串）
	let jsonPar = JSON.parse(base64Decode)
	// 有空格去除空格
	let remove = jsonPar//.replace(/\s*/g,"")
	// 1.在页面显示
	if(!type) return remove
	// 2.在输入框显示 需要再次转换一次 还原成数组 或 对象
	if(type) return eval('(' + remove + ')')
}



const tools = {
	encode64,
	decode64
}
export default tools
